import { Colors } from '@factorialco/deprecated-design-system'
import { BankingValueObjectsCardTypeEnum } from 'generated/resources/graphql'

export const miniatureColor = (card: { type: BankingValueObjectsCardTypeEnum }): Colors => {
  switch (card.type) {
    case 'physical':
      return 'grey000White'
    case 'virtual':
      return 'radicalRed1000'
    case 'single_use':
      return 'viridian1000'
    default:
      return card.type satisfies never
  }
}
